import React, { Component } from 'react';
import { connect } from 'react-redux';

import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('ERRORS_WARNINGS_VISIBILITY_SELECTOR', LOG_LEVELS.DEBUG);

class ErrorsAndWarningsVisibilitySelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      includeErrors: {},
      includeWarnings: {},
      includeHidden: {},
    };
  }

    checkboxChangeHandlerFactory(fieldName) {
      return (event) => {
        log.debug('checkboxChangeHandlerFactory(%s): oldValue: %s, newValue: %s  ', this.props[fieldName], event.target.checked, event);
        let selection = {};
        selection[fieldName] = event.target.checked ? 'true' : 'false';
        this.props.selectionHandler(selection);
      }
    }

    render() {
        log.debug('render():', this.props);
        return (
              <fieldset>
                <legend>Type</legend>
                <span className="clear"></span>
                <input type="checkbox"
                onChange={this.checkboxChangeHandlerFactory('includeErrors').bind(this)}
                checked={typeof this.props.includeErrors === 'string' && this.props.includeErrors.toLowerCase() === 'true'} 
                data-test="error-visibility" />
                <label className="checkbox">{LANGUAGES_CONTROLLER.format(this.props.languages, 'IncludeErrors')}</label>
                
                <input type="checkbox"
                onChange={this.checkboxChangeHandlerFactory('includeWarnings').bind(this)}
                checked={typeof this.props.includeWarnings === 'string' &&  this.props.includeWarnings.toLowerCase() === 'true'} 
                data-test="warning-visibility" />
                <label className="checkbox">{LANGUAGES_CONTROLLER.format(this.props.languages, 'IncludeWarnings')}</label>
                
                <input type="checkbox"
                onChange={this.checkboxChangeHandlerFactory('includeHidden').bind(this)}
                checked={typeof this.props.includeHidden === 'string' && this.props.includeHidden.toLowerCase() === 'true'} 
                data-test="hidden-visibility" />
                <label className="checkbox">{LANGUAGES_CONTROLLER.format(this.props.languages, 'IncludeHidden')}</label>
              </fieldset>
        );
    }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    
    languages: state.languages
  };
}


// Wrap the component to inject state into it
export default connect(mapStateToProps)(ErrorsAndWarningsVisibilitySelector);
